import { css } from "styled-components";
import { colors } from "../colors/color";


// Only used for container, border and text coloring
//----------------------------------
const defaultInputStateCss = css`
    border:1px solid ${colors.inputState.default.border};
`;
export const DefaultInputStateCss = {
    base: {
        container:css`${defaultInputStateCss}`,
        text:css`color: ${colors.inputState.default.text};`,
        placeholderText:css`color: ${colors.inputState.default.placeholderText};`
    },
    hover: css`border:1px solid ${colors.inputState.default.borderHover};`,
    active:css`border:1px solid ${colors.inputState.default.borderActive};`,
    focus:css`border:1px solid ${colors.inputState.default.borderFocus};`
};
//----------------------------------
const errorInputStateCss = css`
    border:1px solid ${colors.inputState.error.border};
`;
export const ErrorInputStateCss = {
    base:{
        container:css`${errorInputStateCss}`,
        text:css`color: ${colors.inputState.error.text};`,
        placeholderText:css`color: ${colors.inputState.error.placeholderText};`
    },
    hover: css`border:1px solid ${colors.inputState.error.border};`,
    active:css`border:1px solid ${colors.inputState.error.borderActive};`,
    focus:css`border:1px solid ${colors.inputState.error.borderFocus};`
};
//----------------------------------
const disabledInputStateCss = css`
    border: 1px solid ${colors.inputState.disabled.border};
    background: ${colors.inputState.disabled.background};
    
`;
export const DisabledInputStateCss = {
    container:css`${disabledInputStateCss}`,
    text:css`color:${colors.inputState.disabled.text};`,
    placeholderText:css`color:${colors.inputState.disabled.placeholderText};`
};